module.exports = __webpack_public_path__ + "static/img/用户端展示.be2842ca.png";